/**
 * @generated SignedSource<<002039d1f48de62e45fabc1c80c85394>>
 * @relayHash 7929245da658efa1d4eecf92ab2cbd78
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7929245da658efa1d4eecf92ab2cbd78

import { ConcreteRequest } from 'relay-runtime';
export type useUserAvailabilityModalQuery$variables = Record<PropertyKey, never>;
export type useUserAvailabilityModalQuery$data = {
  readonly visitor: {
    readonly userAccount: {
      readonly profile: {
        readonly hasCompletedIndyOnboarding: boolean;
        readonly workPreferences: {
          readonly blockAvailabilityReminder: boolean;
          readonly isCurrentlyAvailable: boolean;
        };
      };
    } | null;
  };
};
export type useUserAvailabilityModalQuery = {
  response: useUserAvailabilityModalQuery$data;
  variables: useUserAvailabilityModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasCompletedIndyOnboarding",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkPreferences",
  "kind": "LinkedField",
  "name": "workPreferences",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCurrentlyAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blockAvailabilityReminder",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserAvailabilityModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useUserAvailabilityModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Visitor",
        "kind": "LinkedField",
        "name": "visitor",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserAccount",
            "kind": "LinkedField",
            "name": "userAccount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7929245da658efa1d4eecf92ab2cbd78",
    "metadata": {},
    "name": "useUserAvailabilityModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9ccc7cd068c8ab098ed76cf12a2f5f44";

export default node;
